import { t } from '@lingui/macro'
import { Button } from '@mui/material'
import React, { useState } from 'react'

interface TruncateTextProps {
    text: string
    maxLength?: number
    emptyText?: string
}

export const TruncateText: React.FC<TruncateTextProps> = ({ text, maxLength = 20, emptyText = t`-` }) => {
    const [isExpanded, setIsExpanded] = useState(false)

    if (!text) return <>{emptyText}</>
    if (text.length <= maxLength) return <>{text}</>

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <span>{isExpanded ? text : `${text.slice(0, maxLength)}`}</span>
                {!isExpanded && (
                    <Button
                        size='small'
                        onClick={() => setIsExpanded(true)}
                        sx={{
                            minWidth: 'auto',
                            padding: '0 4px',
                            fontSize: '0.875rem',
                            textTransform: 'none',
                            color: 'primary.main'
                        }}
                    >
                        {t`...`}
                    </Button>
                )}
            </div>
            {isExpanded && (
                <Button
                    size='small'
                    onClick={() => setIsExpanded(false)}
                    sx={{
                        minWidth: 'auto',
                        padding: '0 4px',
                        fontSize: '0.875rem',
                        textTransform: 'none',
                        color: 'primary.main',
                        alignSelf: 'flex-start'
                    }}
                >
                    {t`Show less`}
                </Button>
            )}
        </div>
    )
}
